<!-- Main scene container -->
<div #container class="relative w-full h-full bg-black overflow-hidden">
  <!-- Modern loading overlay -->
  @if (isLoading()) {
    <div class="loading-overlay absolute inset-0 z-50 flex items-center justify-center">
      <div class="loading-backdrop absolute inset-0 bg-black/80 backdrop-blur-sm"></div>
      <div class="loading-content relative z-10 flex items-center justify-center">
        <!-- Animated spinner with percentage inside -->
        <div class="loading-spinner relative w-20 h-20 flex items-center justify-center">
          <div class="spinner-ring absolute inset-0 border-4 border-transparent border-t-blue-500 rounded-full animate-spin"></div>
          <div class="spinner-ring absolute inset-2 border-4 border-transparent border-t-purple-500 rounded-full animate-spin"></div>
          <div class="spinner-ring absolute inset-4 border-4 border-transparent border-t-cyan-500 rounded-full animate-spin"></div>
          <div class="loading-percentage absolute text-sm font-bold text-white">{{ loadingProgressSignal()?.percentage || 0 }}%</div>
        </div>
      </div>
    </div>
  }

  <!-- Error overlay -->
  @if (hasError()) {
    <div class="error-overlay absolute inset-0 z-50 flex items-center justify-center">
      <div class="error-backdrop absolute inset-0 bg-red-900/20 backdrop-blur-sm"></div>
      <div class="error-content relative z-10 flex flex-col items-center space-y-6 p-8 bg-gray-900/90 rounded-2xl border border-red-500/30 max-w-md mx-4">
        <div class="error-icon text-red-500">
          <svg class="w-12 h-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
            <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <div class="error-title text-xl font-bold text-white">Failed to load 360° scene</div>
        <div class="error-message text-gray-300 text-center">{{ errorSignal() || 'Please check your connection and try again.' }}</div>
      </div>
    </div>
  }
</div>
